export const DEFAULT_SELECTED_PERIOD = 365;
export const DEFAULT_RETURNS_CURRENCY_CATEGORY = "crypto";
export const DEFAULT_SELECTED_CURRENCY = "btc";
export const DEFAULT_INVESTED_AMOUNT = 10000;
export const MIN_GRAPH_Y_VALUE = 500;
export const CURRENCY_PRICE_TICKER_SUFFIX = "inr";
export const MAX_VALUE_PRECISION = 2;

export const SUPPORTED_CURRENCIES = [
  {
    label: "Bitcoin",
    value: "btc",
    icon: "",
  },
  {
    label: "Ethereum",
    value: "eth",
    icon: "",
  },
  {
    label: "WazirX Token",
    value: "wrx",
    icon: "",
  },
  {
    label: "Binance Token",
    value: "bnb",
    icon: "",
  },
];

export const RETURNS_TYPES = {
  crypto: {
    label: "Cryptocurrency",
  },
  gold: {
    label: "Gold",
  },
  nse: {
    label: "Nifty",
  },
  fd: {
    label: "Fixed Deposit",
  },
};

export const INVESTMENT_PERIODS_RANGE = [
  {
    value: 7,
    label: "1W",
  },
  {
    value: 30,
    label: "1M",
  },
  {
    value: 90,
    label: "3M",
  },
  {
    value: 180,
    label: "6M",
  },
  {
    value: 365,
    label: "1Y",
  },
  {
    value: 730,
    label: "2Y",
  },
  {
    value: 1095,
    label: "3Y",
  },
  {
    value: 1460,
    label: "4Y",
  },
  {
    value: 1825,
    label: "5Y",
  },
  {
    value: 3650,
    label: "10Y",
  },
];
